export const SlbOceanPdpPageTemplate = {
    slots: ['SlbOceanPdpContainerSlot', 'SlbBlueBottomBannerSlot'],  
};
  
export const SlbPluginAndExtensionsPDPPageTemplate = {
    slots: ['SlbPluginAndExtensionsPDPFeatureSlot'],  
};